import axios from "axios";
import authService from "./authService";

const fetchData = async (apiData, path) => {
  try {
    const encData = authService.enc(apiData);
    const content = {
      content: encData,
    };

    let config = {
      method: "POST",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/${path}`,
      headers: {
        "Content-Type": "application/json",
        "access-token":authService?.getAccessToken()
      },
      data: content,
    };

    const response = await axios
      .request(config)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });

      if (response.data.error) {
        throw response.data.error
      }

    if (response.data) {
      if (path == "excelupload") {
        const res =
          JSON.parse(authService.dec(response.data)) ||
          authService.dec(response.data);
        if (res.error) {
          return {
            error: {
              message: res?.error,
            },
          };
        } else {
          return {
            data: res,
          };
        }
      }
      const decData = JSON.parse(authService?.dec(response.data));
      if (decData?.data) {
        return decData;
      } else if(decData.error){
        return decData.error
      } else {
        throw "err";
      }
    } else {
      throw "err";
    }
  } catch (err) {
    console.log(err);
    if (err?.errorcode==500) {
      sessionStorage.clear();
      window.location.reload()
      return {
        error: {
          code: "AUTH_ERR",
          message: "Session Expired.",
        },
      };
    }
    return {
      error: {
        code: "TECH_ERR",
        message: "Technical Error, Please check after some times.",
      },
    };
  }
};

const apiService = {
  fetchData: (data, path) => fetchData(data, path),
};

export default apiService;
